import { factory } from './utils';

import httpClient from '@/utils/httpClient';

export default {
  namespaced: true,
  ...factory({
    actions: {
      async getUserOrganizations() {
        const userOrganizations = await httpClient.get(`/api/organizations/user`);
        return userOrganizations.map((org) => ({
          id: org.id,
          label: org.name
        }));
      }
    }
  })('organizations', {
    async getById(id) {
      const result = await Promise.all([
        await httpClient.get(`/api/organizations/${id}`),
        await httpClient.get(`/api/v2/nlp/permissions/organizations/${id}/models`)
      ]);

      const organization = result[0];
      organization.models = result[1] ?? [];

      return organization;
    },
    async getCollection() {
      return await httpClient.get(`/api/organizations/`);
    },
    async create(obj) {
      const models = obj.models || [];
      delete obj.models;

      const organization = await httpClient.post(`/api/organizations/`, obj);

      if (models.length && organization?.id) {
        await httpClient.post(`/api/v2/nlp/permissions/organizations/${organization.id}/models`, { models });
        organization.models = models;
      }

      return organization;
    },
    async update(id, data) {
      const models = data.models || [];
      delete data.models;

      const result = await Promise.all([
        httpClient.patch(`/api/organizations/${id}`, data),
        httpClient.post(`/api/v2/nlp/permissions/organizations/${id}/models`, { models })
      ]);

      const organization = result[0];
      organization.models = models;

      return organization;
    },
    async delete(id) {
      return httpClient.delete(`/api/organizations/${id}`);
    }
  })
};
